

import CurrentTenders from "./CurrentTenders";
import AwardedTenders from "./AwardedTenders";
import CancelledTenders from "./CancelledTenders";
import React, { useEffect, useState } from "react";
import AwardedT from "./AwardedT";
import { useLocation, useNavigate } from "react-router-dom";


const sectionComponents = {
  "Current-Tenders": <CurrentTenders />,
  "Awarded-Tenders": <AwardedTenders />,
  "Cancelled-Tenders": <CancelledTenders />,
  "Awarded-T": <AwardedT/>,
};

function TenderTabs() {
   const location = useLocation();
   const navigate = useNavigate();
   const queryParams = new URLSearchParams(location.search);
   const initialSection = queryParams.get("section") || "CurrentTenders";

   const [currentSection, setCurrentSection] = useState(initialSection);

  const handleClick = (section) => {
    setCurrentSection(section);
    navigate(`/Tenders?section=${section}`);
    const closeBtn = document.querySelector(".btn-cus");
    if (closeBtn) closeBtn.click();
  };
  useEffect(() => {
  const updatedSection = queryParams.get("section");
  setCurrentSection(updatedSection);
  const el = document.getElementById(currentSection);
  if (updatedSection && sectionComponents[updatedSection]) {
    if (el && queryParams.get("section") !== null) {
        const yOffset = -150;
        const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
        setTimeout(() => {
          window.scrollTo({ top: y, behavior: "smooth" });
        }, 100);
      } else {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 100);
      }
    const isCadetship = updatedSection.toLowerCase() === "cadetship" || updatedSection.toLowerCase() === "cadetshiptraining";
    const collapseEl = document.getElementById("collapseTwo");
    if (collapseEl && !isCadetship && collapseEl.classList.contains("show")) {
      collapseEl.classList.remove("show");
    }
  } else {
    setCurrentSection("Current-Tenders");
    const collapseEl = document.getElementById("collapseTwo");
    if (collapseEl) collapseEl.classList.remove("show");
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  }
}, [location.search,location]);

  return (
    <section className="ManagementTeam px-3 small-anchor" id="ManagementTeam">
      <div className="container max-1330 mx-auto">
        <div className="row g-3 g-sm-4 g-md-5">
          <div className="col-lg-3">
              <div className="position-stiicky top-150">
                <div className="d-lg-none text-end">
                  <i
                    className="bi bi-list  border-0 ms-auto font-32"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                    aria-controls="offcanvasResponsive"
                  ></i>
                </div>
                <div
                  className="offcanvas-lg offcanvas-end"
                  tabIndex="-1"
                  id="offcanvasResponsive"
                  aria-labelledby="offcanvasResponsiveLabel"
                >
                  <div className="offcanvas-header d-lg-none">
                    <h5 className="offcanvas-title" id="offcanvasResponsiveLabel">
                      Our Services
                    </h5>
                    <button
                      type="button"
                      className="btn-close btn-cus"
                      data-bs-dismiss="offcanvas"
                      data-bs-target="#offcanvasResponsive"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div
                    className="accordion leftMenu px-3 px-lg-0 pb-3 pb-md-0 overflow-auto overflow-md-visible"
                    id="accordionExample"
                  >
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                           className={`accordion-button noAfter  ${currentSection === "CurrentTenders" ? "collapsed gray-active" : "collapsed"}`}
                                onClick={() => handleClick("CurrentTenders")}
                        >
                          Current Tenders
                        </button>
                      </h2>
                 
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                           className={`accordion-button noAfter  ${currentSection === "Awarded-Tenders" ? "collapsed gray-active" : "collapsed"}`}
                                onClick={() => handleClick("Awarded-Tenders")}
                        >Awarded Tenders
                        </button>
                      </h2>                
                    </div>             
                    
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button                         
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                          className={`accordion-button noAfter  ${currentSection === "Cancelled-Tenders" ? "collapsed gray-active" : "collapsed"}`}
                                onClick={() => handleClick("Cancelled-Tenders")}
                        >Cancelled Tenders
                        </button>
                      </h2>
                 
                    </div>

                    {/* <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button                         
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                          className={`accordion-button noAfter  ${currentSection === "Awarded-T" ? "collapsed gray-active" : "collapsed"}`}
                                onClick={() => handleClick("Awarded-T")}
                        >Awarded T
                        </button>
                      </h2>
                 
                    </div> */}

                    <div className="accordion-item d-none">
                      <h2 className="accordion-header">
                        <button
                          
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                           className={`accordion-button noAfter  ${currentSection === "maritime-studies" ? "collapsed gray-active" : "collapsed"}`}
                                onClick={() => handleClick("maritime-studies")}
                        >
                         Maritime Studies
                        </button>
                      </h2>
                 
                    </div>

                   
                  </div>
                </div>
              </div>
            </div>

          <div className="col-lg-9 col-md-8">
            <div id={currentSection}>
              {sectionComponents[currentSection] || <CurrentTenders />}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TenderTabs;
